import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
import Button from '@material-ui/core/Button';
import {connect} from "react-redux";
import Paper from '@material-ui/core/Paper';
import Toolbar from "@material-ui/core/Toolbar";
import AppBar from "@material-ui/core/AppBar";

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    },
    debutton:{
        padding:'5px 12px',
        //background:theme.navigation.selected.backgroundColor,
        //color:theme.navigation.selected.contrast,
        borderRadius:3,
        boxShadow:'2px 2px 2px #eee',

        '&:hover':{
            //background:theme.navigation.hover.backgroundColor,
            //color:theme.navigation.selected.contrast,
        }
    },
    formControl:{
      width:'100%'
    }
});

class Confirmation extends Component {
    state={
        amount: 0,
        comment:'',
        currency:'USD',
        journal_type:'JOURNAL',
        emailContent: this.props.emailContent.replace('{comment}',this.props.comment)
    };

    close = () =>{
        this.props.context.update({
            popupContent: false,
        })
    };

    update = (e) => {
        let comment = (this.state.comment !== '') ? '<p style=\'color:red;\'><strong>Additional message to Investor:</strong><br><br>{comment}</p>'.replace('{comment}',this.state.comment) : '';
        this.setState({
            comment:e.target.value,
            emailContent: this.props.emailContent.replace('{comment}',comment)
        })
    }

    confirm = () => {
        this.props.updateComment(this.state.comment);
    }

    render() {

        return (
            <React.Fragment>
                <div className={'flex'}>
                  <Paper clsssName={"flex-1"} style={{width:'400px',marginRight:'15px'}}>
                      <AppBar position="static" elevation={0} color={"default"} style={{boxShadow: 'none'}}>
                          <Toolbar>
                              <b>Email Content</b>
                          </Toolbar>
                      </AppBar>
                      <div dangerouslySetInnerHTML={{__html:this.state.emailContent}} style={{padding:'10px',height:'300px', overflow:'auto'}}/>
                  </Paper>

                  <Paper clsssName={"flex-1"} style={{width:'200px'}}>
                      <AppBar position="static" elevation={0} color={"default"} style={{boxShadow: 'none'}}>
                          <Toolbar>
                              <b>Additional Comments</b>
                          </Toolbar>
                      </AppBar>
                      <div style={{padding:'10px', height:'250px'}}>
                          <textarea onChange={this.update} value={this.state.comment} style={{height:'100%'}}/>
                      </div>
                      <div style={{padding:'5px', height:'50px'}}>
                          <Button  variant="contained" color="secondary" onClick={this.confirm} >
                            Confirm
                          </Button>

                          <Button  variant="outlined" color="secondary" onClick={this.close}>
                            Close
                          </Button>
                      </div>
                  </Paper>
                </div>
            </React.Fragment>
        )
    }
}

function mapStateToProps({auth})
{
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Confirmation))));
